<script setup lang="ts">
import type {NuxtError} from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})

const { t } = useI18n()

useSeoMeta({
  title: `${props.error?.statusCode || '404'} - Risalah Online`,
  robots: 'noindex, nofollow',
})

const statusMessage = computed(() => props.error?.statusMessage || t('error.default-status-message'))

const description = computed(() => {
  const message = props.error?.message
  if (!message) {
    return t('error.default-description')
  }

  if (message === props.error?.statusMessage) {
    return t('error.default-description')
  }

  return message
})

const shouldShowDescription = computed(() => {
  return description.value && description.value !== statusMessage.value
})

const handleError = () => {
  try {
    clearError({ redirect: '/' })
  } catch (e) {
    window.location.href = '/'
  }
}

if (props.error) {
  console.error('Error occurred:', props.error)
}
</script>

<template>
  <NuxtLayout>
    <div class="min-h-[50vh] flex items-center justify-center py-8">
      <div class="w-full max-w-md mx-auto text-center">
        <div class="mb-8">
          <h1 class="text-8xl font-bold mb-4">
            {{ error?.statusCode || '404' }}
          </h1>
          <div class="w-16 h-1 bg-hayrat mx-auto rounded-full mb-6"></div>

          <h2 class="text-on-surface-low mb-4">
            {{ statusMessage }}
          </h2>
          <p v-if="shouldShowDescription" class="mb-8">
            {{ description }}
          </p>
        </div>
        <button
            @click="handleError"
            class="w-full px-4 py-3 bg-hayrat text-white rounded-lg hover:bg-hayrat/90 transition-colors font-medium">
          {{ t('error.go-home') }}
        </button>
      </div>
    </div>
  </NuxtLayout>
</template>
